<div *ngIf="successMessage" class="alert alert-success" role="alert">
  <mat-icon>thumb_up</mat-icon> &nbsp;
  <span style="vertical-align: text-bottom; margin-bottom: 0rem;">
    {{successMessage}}
  </span>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">

  <span style="vertical-align: text-bottom; margin-bottom: 0rem;">
    {{errorMessage}}
  </span>
</div>

<div class="row_1">
  <div class="top_grid_agg">
    <div class="content">
          <div style="width: 50%; justify-content: left; display: flex;">
            <button routerLink="/newtask" class="back_button col-sm-1">BACK</button>
          </div>
		  <div style="width: 50%; justify-content: right; display: flex;">
            <button class="add_button col-sm-1 float-right" (click)="addtask()">CREATE</button>
          </div>
        </div>
    <div class="period-form">
      <form class="form-horizontal hr">
        <div class="form-group row">
          <div class="col-sm-7">
            <div class="template-row">

              <label class="control-label col-sm-4">Template:
                <span style="color:#ff0000">*</span>
              </label>
              <div class="col-sm-8">
                <select class="template" [(ngModel)]="selected_template" [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let template of templates" [value]="template.templateID">
                    {{template.description}}
                  </option>
                </select>
              </div>
            </div>

            <div class="period-row">
              <label class="control-label col-sm-4">Period:
                <span style="color:#ff0000">*</span>
              </label>
              <div class="col-sm-8">
                <select [(ngModel)]="selected_period" [ngModelOptions]="{standalone: true}">
                  <option *ngFor="let period of periodData" [value]="period.periodId">
                    {{period.name}} {{period.year}}
                  </option>
                </select>
              </div>
            </div>

            <div class="base-row">
              <label class="control-label col-sm-4" for="fname" aria-describedby="base-desc">Base Date:
                <span style="color:#ff0000">*</span>
                <p id="base-desc" class="form-text">(D-0, Due date, etc) &nbsp;</p>
              </label>
              <div class="col-sm-8">
                <input type="date" id="base-date" [(ngModel)]="selected_date" [ngModelOptions]="{standalone: true}">
              </div>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>